<template>
  <div id="container">
    <div id="content-wrap">
      <NavBar :site="site" :mobile="isMobile" :info="info"/>
      <router-view class="router-view" :mobile="isMobile" :info="info"/>
    </div>
    <Footer :site="site" :mobile="isMobile" :info="info"/>
  </div>
</template>

<script>
import { isMobile } from 'mobile-device-detect';
import NavBar from '@/components/NavBar.vue';
import Footer from '@/components/Footer.vue';
export default {
  name: 'App',
  components: {
    NavBar,
    Footer
  },
  data: () => {
    return {
      site: 'Allon Construction',
      isMobile,
      info: {
        link: 'https://www2.cslb.ca.gov/OnlineServices/CheckLicenseII/LicenseDetail.aspx?LicNum=630785',
        tel: 'tel:+18189150605',
        lic: 'License #630785',
        num: '(818) 915 - 0605'
      }
    }
  }
};
</script>

<style>
html {
  background: #fdfbf6e3;
}
#container {
  /* font-family: cormorant-garamond, serif; */
  font-family: 'Open Sans', sans-serif;
  /* font-family: 'Amiri', serif; */

  font-weight: 300;
  font-style: normal;
  position: relative;
  min-height: 100vh;
}
h1 {
  font-size: 2.25rem;
  padding: 1rem;
  letter-spacing: .1em;
  font-weight: 300;
  margin: auto;
  text-align: center;
  width: 75%;
  margin-bottom: .5rem;
}
h2 {
  font-size: 2rem;
  padding: 1rem;
  letter-spacing: .1em;
  font-weight: 300;
  margin: auto;
  text-align: center;
  /* width: 75%; */
  margin-bottom: .5rem;
}
#content-wrap {
  padding-bottom: 5rem;    /* Footer height */
}
#footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 2.5rem;            /* Footer height */
}
 img[lazy=loading] {
    /*your style here*/
    width: 10% !important;
    height: auto !important;
    text-align: center;
    margin: auto;
    vertical-align: middle;
    display: table-cell;
  }
.red {
  color: rgb(182, 40, 40);
}
</style>